import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import StudioAdmin from "@/pages/StudioAdmin";
import DemoPage from "@/pages/DemoPage";

function SmoothScroll({ children }) {
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    const hash = window.location.hash;
    if (hash && location.pathname === "/") {
      const target = document.querySelector(hash);
      if (target) {
        setTimeout(() => lenis.scrollTo(target, { duration: 1.6 }), 400);
      }
    }
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, [location.pathname]);

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/studio-admin" element={<StudioAdmin />} />
            <Route path="/d/:slug" element={<DemoPage />} />
          </Routes>
        </div>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
